import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ApplicationSubmittedPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const caseNumber = location.state?.caseNumber || '';

  return (
    <div style={{ maxWidth: '700px', margin: '2rem auto', padding: '1rem' }}>
      <div style={{
        backgroundColor: '#d4edda',
        border: '1px solid #c3e6cb',
        borderRadius: '8px',
        padding: '2rem',
        textAlign: 'center'
      }}>
        <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>✅</div>
        <h1 style={{ color: '#155724', marginBottom: '1rem' }}>Application Submitted Successfully!</h1>
        <p style={{ fontSize: '1.1rem', marginBottom: '1.5rem', color: '#155724' }}>
          Your DUI First Time Offender Program application has been received and is currently under review.
        </p>

        {caseNumber && (
          <div style={{
            backgroundColor: '#e9f2ff',
            border: '1px solid #b7d3ff',
            borderRadius: '8px',
            padding: '1.25rem',
            marginBottom: '1.5rem',
            display: 'inline-block',
            minWidth: '300px'
          }}>
            <p style={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.08em', color: '#375a93', marginBottom: '6px', margin: 0 }}>
              Your Tracking Number
            </p>
            <p style={{ fontSize: '24px', fontWeight: '800', color: '#0f2d62', margin: '8px 0 0 0', fontFamily: 'monospace' }}>
              {caseNumber}
            </p>
          </div>
        )}

        <div style={{
          backgroundColor: '#fff3cd',
          border: '1px solid #ffeaa7',
          borderRadius: '6px',
          padding: '1rem',
          marginBottom: '1rem',
          textAlign: 'left'
        }}>
          <p style={{ margin: '0 0 8px 0', fontWeight: 'bold', color: '#856404' }}>📝 Important Information</p>
          <ul style={{ margin: 0, paddingLeft: '1.25rem', color: '#856404' }}>
            <li>A confirmation email has been sent to your registered email address with your tracking number.</li>
            <li>You are still <strong>RESPONSIBLE</strong> for appearing at your next court date unless otherwise directed by the Court or your attorney.</li>
            <li>Please save your Tracking Number for future reference.</li>
            <li>Once your application is reviewed and approved, you will be notified by email.</li>
          </ul>
        </div>

        <div style={{
          backgroundColor: '#e2e3e5',
          border: '1px solid #d6d8db',
          borderRadius: '6px',
          padding: '1rem',
          marginBottom: '1.5rem',
          textAlign: 'left'
        }}>
          <p style={{ margin: '0 0 8px 0', fontWeight: 'bold', color: '#383d41' }}>🔄 Next Steps</p>
          <ol style={{ margin: 0, paddingLeft: '1.25rem', color: '#383d41' }}>
            <li>Check your email for a registration confirmation with your tracking number.</li>
            <li>Keep your Tracking Number — you will need it to check your status.</li>
            <li>An SAO representative will review your application.</li>
            <li>Once approved, you will receive a notification email.</li>
            <li>Contact support if you have any questions.</li>
          </ol>
        </div>

        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          {caseNumber && (
            <button
              onClick={() => navigate('/status', { state: { caseNumber } })}
              style={{
                backgroundColor: '#1f3b73',
                color: 'white',
                border: 'none',
                padding: '0.75rem 1.5rem',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '1rem',
                fontWeight: '600'
              }}
            >
              Check Application Status
            </button>
          )}
          <button
            onClick={() => navigate('/')}
            style={{
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              padding: '0.75rem 1.5rem',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '1rem'
            }}
          >
            Return to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApplicationSubmittedPage;
